module.exports = __webpack_public_path__ + "materialdesignicons-webfont.8a4927f053e671531ae9.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.svg?v=1.8.36
// module id = ../../../../../src/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.svg?v=1.8.36
// module chunks = styles